
    import './styles.scoped.css';
    export default {
  "dropdown-content-wrapper": "awsui_dropdown-content-wrapper_qwoo0_1b3x1_99",
  "awsui-motion-fade-in-dropdown": "awsui_awsui-motion-fade-in-dropdown_qwoo0_1b3x1_1",
  "refresh": "awsui_refresh_qwoo0_1b3x1_120",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_qwoo0_1b3x1_1",
  "root": "awsui_root_qwoo0_1b3x1_149",
  "interior": "awsui_interior_qwoo0_1b3x1_185",
  "dropdown": "awsui_dropdown_qwoo0_1b3x1_99",
  "use-portal": "awsui_use-portal_qwoo0_1b3x1_196",
  "is-empty": "awsui_is-empty_qwoo0_1b3x1_249",
  "dropdown-drop-up": "awsui_dropdown-drop-up_qwoo0_1b3x1_252",
  "with-limited-width": "awsui_with-limited-width_qwoo0_1b3x1_256",
  "dropdown-drop-left": "awsui_dropdown-drop-left_qwoo0_1b3x1_259",
  "dropdown-drop-right": "awsui_dropdown-drop-right_qwoo0_1b3x1_265",
  "occupy-entire-width": "awsui_occupy-entire-width_qwoo0_1b3x1_271",
  "stretch-beyond-trigger-width": "awsui_stretch-beyond-trigger-width_qwoo0_1b3x1_274",
  "hide-upper-border": "awsui_hide-upper-border_qwoo0_1b3x1_278",
  "open": "awsui_open_qwoo0_1b3x1_285",
  "nowrap": "awsui_nowrap_qwoo0_1b3x1_294",
  "dropdown-content": "awsui_dropdown-content_qwoo0_1b3x1_99",
  "stretch-trigger-height": "awsui_stretch-trigger-height_qwoo0_1b3x1_305"
};
  